import { Routes } from "@angular/router";
import { AuthGuard } from "./core/guards/auth.guard";
import { PermisoGuard } from "./core/guards/permiso.guard";

export const routes: Routes = [
  {
    path: "auth",
    loadChildren: () =>
      import("./pages/auth/auth.routes").then((m) => m.AUTH_ROUTES),
  },
  {
    path: "dashboard",
    loadChildren: () =>
      import("./pages/dashboard/dashboard.routes").then(
        (m) => m.DASHBOARD_ROUTES,
      ),
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard, PermisoGuard],
  },
  {
    path: "vista-previa",
    loadChildren: () =>
      import("./pages/vistaprevia/vista-previa.routes").then((m) => m.VISTAPREVIA_ROUTES),
  },
  {
    path: "",
    pathMatch: "full",
    redirectTo: "auth/ingreso",
  },
  {
    // Carga directa (no lazy): si se cortó la conexión, el chunk de un loadComponent
    // podría no descargarse y la navegación a esta pantalla fallaría.
    path: "sin-conexion",
    loadComponent: async () =>
      (await import("./pages/sinconexion/sin-conexion.component"))
      .SinConexionComponent,
      title: "Sin conexión | COBRO SIMPLE",
  },
  {
    path: "404",
    loadComponent: async () =>
      (await import("./pages/404/page-not-found.component"))
        .PageNotFoundComponent,
    title: "404 Not Found | COBRO SIMPLE"
  },
  {
    path: "**",
    redirectTo: "404",
  },
];